import { useEffect, useRef, useState } from "react";
import React from "react";
import "./parentragistrationform.css";
import { useLocation, useNavigate } from "react-router-dom";
import {
  imageUrl,
  makeFormDateRequset,
  makeGetRequest,
} from "../../services/api";
import { URLS } from "../../constants";
import "react-toastify/dist/ReactToastify.css";
import ImgCrop from "antd-img-crop";
import { Upload } from "antd";
import jwt_decode from "jwt-decode";
import { PlusOutlined } from "@ant-design/icons";
import { makePostRequest } from "../../services/api";
import { capitalizeWords, toastifyMessage, Emailvalidation, decodeToken } from "../../utilities/CustomFunctions";
import { useDispatch } from "react-redux";
import FourDotsLoader from "../Common.WebAppMate/FourDoted";
import { getchildList, setUserData } from "../../store/reducers/userReducer";
import Select from "react-select";
// import StripePopup from "../Common.WebAppMate/StripePopup";
import Head from "../Layout.WebAppMate/head/Head";
import { options } from "../../services/common.services";
import axios from 'axios';
import 'react-phone-input-2/lib/style.css';


// /*
//      * Parentregistration  function is used to register user
//      * @author Naresh Kumar <naresh.gulati@webappmate.com>
//      * created on: 15-4-2023
//      * /

const Parentrgistrationformnew = () => {
  let Zipcode = /^[a-zA-Z0-9]{5,6}$/;
  let userData = decodeToken();
  let dispatch = useDispatch();
  let my_token = localStorage.getItem("auth-token");
  let useractive = localStorage.getItem("useractive");
  const headers = { Authorization: "Bearer " + my_token };
  const fref = useRef();
  const lref = useRef();
  const imgref = useRef();
  const zref = useRef();
  const userRef = useRef();
  let uimage = imageUrl;
  const urlSearchParams = new URLSearchParams(window.location.search);
  const queryParams = Object.fromEntries(urlSearchParams.entries());
  const [firstname, setfirstname] = useState("");
  const [lastname, setlastname] = useState("");
  const [error, seterror] = useState(false);
  const [file, setFile] = useState("");
  const [userType, setUserType] = useState([]);
  const [imgflag, setimgflag] = useState(false);
  const [zipcode, setZipcode] = useState("");
  const [status, setStatus] = useState(false);
  const navigate = useNavigate();
  const [zipCode, setZipCode] = useState("");
  const location = useLocation();
  const state = location.state;
  const [loading, setLoading] = useState(false);
  const [userTypeData, setUserTypeData] = useState([]);
  const [user, setUser] = useState([]);
  const [email, setEmail] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);

  console.log(userTypeData,"userTypeData..")
  const [fileList, setFileList] = useState([
    {
      uid: "-1",
      url: "",
    },
  ]);


  //--start these functios are use for image
  const onChange = async ({ fileList: newFileList }) => {
    setFileList(newFileList);
  };

  const beforeCrop = (file) => {
    if (
      file.name.toLowerCase().includes("jpg") ||
      file.name.toLowerCase().includes("png") ||
      file.name.toLowerCase().includes("jpeg")
    ) {
      setimgflag(false);
      return true;
    } else {
      setimgflag(true);
      return false;
    }
  };

  // this function use for remove profile image
  const onRemove = async () => {
    setimgflag(false);
    makePostRequest(URLS.profileImageDelete, null, {}, null)
      .then((res) => {
        toastifyMessage(res.message, "success")
      }).catch((error) => {
        console.log("error::", error)
      })
  };
  //--end these functios are use for image

  //--function for fetching user detail
  const handleshowupload = () => {
    setLoading(true);
    let data = {
      id: userData.userAuth.id,
    };
    makePostRequest(URLS.userfetchdata, null, data, null).then((response) => {
      console.log("res:::.........................", response)
      setLoading(false);
      if (response?.data?.uesrData?.firstName !== null) {
        setStatus(true);
      }
      setFileList([{ url: uimage + response.data.uesrData.photo }]);
      if (file.includes("undefined") || file.includes("null")) {
        setFile("");
      }
    });
  };
  
  
  //===Function for uploading  user image===//
  function uploadimage(cropimage) {
    const formData = new FormData();
    formData.append("photo", cropimage ? cropimage : "");
    formData.append("id", userData.userAuth.id);
    makeFormDateRequset(URLS.useruploadprofile, formData).then((response) => {
      if (response?.code === 200) {
        setFileList([{ url: uimage + response.data.photo }]);
        toastifyMessage(response.message, "success");
        setTimeout(() => {
          makeGetRequest(URLS.token, null, { headers }).then((re) => {
            localStorage.setItem("auth-token", re?.data?.authorization);
          });
        }, 500);
        setTimeout(() => {
          let data = {
            id: userData.userAuth.id,
          };
          makePostRequest(URLS.userfetchdata, null, data, null).then((res) => {
            if (res?.code === 200) {
              dispatch(setUserData({ name: res.data.uesrData.firstName, image: res.data.uesrData.photo }))
            }
          });
        }, 700);
      }
    });
  }
 
  const handleZipCode = (e) => {
    setZipcode(e.target.value);
  }


  // this function is use get the user tyep
  const handleuser = () => {
    makeGetRequest(URLS.userroleget, null, null)
      .then((res) => {
        const result = res.data?.map(item => ({
          value: item?.id,
          label: item?.role_name
        }));
        setUser(result)
      })
      .catch((error) => { })
  }
 
 const handleStartedwithMatched = () => {
  if (isSubmitting) return; // Block repeated clicks
  setIsSubmitting(true); // API in progress

  let isValid = true;
  seterror(true);

  const zipTrimmed = zipcode?.replace(/\s/g, "");

  if (
    firstname.trim() === "" ||
    lastname.trim() === "" ||
    zipcode.trim() === "" ||
    (!Zipcode.test(zipTrimmed) && zipTrimmed !== "111111") ||
    userTypeData.length === 0
  ) {
    setIsSubmitting(false); // Reset flag on invalid form
    return;
  }

  setLoading(true);

  const data = {
    // firstName: firstname,
    // lastName: lastname,
    firstName: capitalizeWords(firstname.replaceAll("_", " ")),
    lastName: capitalizeWords(lastname?.replaceAll("_", " ")),
    zipcode: zipcode,
    user_type_role_id: userTypeData?.map((item) => item.value),
    default: true
  };

  // console.log(data, "data...");

  makePostRequest(URLS.updateprofileNew, null, data, null)
    .then((res) => {
      // console.log(res, "resprofile..");
      setLoading(false);

      if (res?.code === 200) {
        toastifyMessage(res.message, "success");

        makeGetRequest(URLS.token, null, { headers }).then((re) => {
          const my_token = re?.data?.authorization;
          localStorage.setItem("auth-token", my_token);
          const decoded = my_token ? jwt_decode(my_token) : "";

          dispatch(setUserData({
            name: res?.firstName,
            image: res?.photo || ""
          }));

          localStorage.setItem("fristname", decoded.userAuth.firstName);
        });

        setTimeout(() => {
          navigate('/');
        }, 2000);
      }

    })
    .catch((error) => {
      console.log(error);
      setIsSubmitting(false); // Only reset on error
      setLoading(false);
    });
};
 const UpdateProfilePage = () => {
    let isValid = true;
  seterror(true); // to trigger error display

  // Remove spaces from zip code for validation
  const zipTrimmed = zipcode?.replace(/\s/g, "");

  if (
    firstname.trim() === "" ||
    lastname.trim() === "" ||
    zipcode.trim() === "" ||
    (!Zipcode.test(zipTrimmed) && zipTrimmed !== "111111") ||
    userTypeData.length === 0
  ) {
    isValid = false;
  }
    if (!isValid) {
    return; 
  }

    setLoading(true);
    let data = {
     firstName: capitalizeWords(firstname.replaceAll("_", " ")),
    lastName: capitalizeWords(lastname?.replaceAll("_", " ")),
    "zipcode":zipcode,
    "user_type_role_id":userTypeData?.map((item) => item.value),
    "default":false
    };
console.log(data,"data...")
    makePostRequest(URLS.updateprofileNew, null, data, null)
       .then((res) => {
        console.log(res,"resprofile..")
           if (res.code === 200) {
              setLoading(false);
             toastifyMessage(res.message, "success")
              if (res.code === 200) {
                           makeGetRequest(URLS.token, null, { headers }).then((re) => {
                             let my_token = re?.data?.authorization;
                             localStorage.setItem("auth-token", re?.data?.authorization);
                             var decoded = my_token ? jwt_decode(my_token) : "";
                             // console.log(decoded.userAuth.firstName)
                              dispatch(setUserData({ name: res?.firstName, image: res?.photo ? res?.photo  :""}))
                             localStorage.setItem("fristname", decoded.userAuth.firstName);
                           });
                          }
            //    setTimeout(() => {
					  //     navigate('/')
						//  }, 2000)
             setTimeout(() => {

					      navigate('/parent-registration-form')
						 }, 2000)
          
           }
       })
       .catch((error) => {
          console.log(error);
       });
  };
 
  useEffect(() => {
    handleuser()
    if (useractive === "") {
      navigate("/sign-in");
    }
    handleshowupload();
    document.body.classList.add("parentragistrationform","parentragistrationformnew");
    return () => {
      document.body.classList.remove("parentragistrationform","parentragistrationformnew");
    };
  }, []);

  return (
    <>
      {loading && (
        <div className="sharepopupOuter backgroundOpacity1">
          <FourDotsLoader />
        </div>
      )}
     
      <Head title="Create Profile"
        content="The growth of homeschooling and microschools (now over 6M children nationally), supplementary educational services (tutors, test prep, camps, etc.) and school choice (ESAs, vouchers, tax credits) has created a large market of educators/parents with full flexibility to personalize learning.  However, it is very overwhelming and challenging to sort through all the options to find the right fit for their child."
        name="Create Profile" ></Head>  
       
      {/* <div className={`${status === true ? "col-lg-12" : "containerparent"}`}> */}
<div className={ "col-lg-12" }>
        <div className="owncontainer">
        
          <form ref={imgref} onSubmit={(event) => event.preventDefault()} className="form-contain-inner">
          <h3 className="profile-prefer">Profile & Preferences</h3>
            <div className="profile-div">
              <div className="input-file1">
                <div className="upload11" >Upload photo</div>
              </div>
              <ImgCrop
                cropperProps={{ restrictPosition: false }}
                cropShape="round"
                showGrid
                minZoom={0.2}
                zoomSlider
                rotationSlider
                showReset
                // aspect={2 / 1.9}
                aspect={10.5 / 9}
                height={1200}
                beforeCrop={(file) => beforeCrop(file)}
                onModalOk={(cropedimg) => uploadimage(cropedimg)}
              >
                {fileList ? (
                  <Upload
                    action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                    listType="picture-circle"
                    onChange={onChange}
                    onRemove={onRemove}
                    // beforeUpload={beforeUpload}
                    fileList={fileList}
                  >
                    {fileList === "" && (
                      <div className="text">
                        {" "}
                        <PlusOutlined /> upload
                      </div>
                    )}
                  </Upload>
                ) : (
                  <>
                    <Upload
                      action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                      listType="picture-circle"
                      onChange={onChange}
                    >
                    </Upload>
                  </>
                )}
              </ImgCrop>
            </div>
            {imgflag === true ? (
              <span className="error"> Only png, jpg, jpeg are allowed</span>
            ) : null}

            <div className="form-container-parent">
              <div className="row">
                <div className="col-12 col-sm-6 col-md-6 col-lg-6">
                  <label className="form-label0">
                    First Name<span className="start-color">*</span>
                  </label>
                  <input
                  placeholder="Enter First Name"
                    type="text"
                    className="form-control input-control"
                    id="input1"
                    ref={fref}
                    onChange={(e) => setfirstname(e.target.value.trimStart())}
                    value={firstname}
                  />
                  {error && firstname === "" ? (
                    <span className="error1"> Please enter first name </span>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-12 col-sm-6 col-md-6 col-lg-6">
                  <label className="form-label0 last-name-parents">
                    Last Name<span className="start-color">*</span>
                  </label>
                  <input
                    type="text"
                     placeholder="Enter Last Name"
                    className="form-control input-control"
                    id="input2"
                    ref={lref}
                    onChange={(e) => setlastname(e.target.value)}
                    value={lastname}
                  />
                  {error && lastname === "" ? (
                    <span className="error1"> Please enter last name </span>
                  ) : (
                    ""
                  )}

                </div>
              </div>
              <div className="row">
                <div className="col-lg-6">
               <div className="zip-code-inner zip-code-inner1">
                    <label className="form-label0">
                      Zip Code<span className="start-color">*</span>
                    </label>
                    <input
                      type="text"
                       placeholder="Enter Zipcode"
                      className="form-control input-control"
                      id="inputphone"
                      onChange={handleZipCode}
                      value={zipcode}
                      ref={zref}
                    />
                    <span className="select-one">
                      <div className="facustomeI">i<div className="tootlippillerinfo">
                        For users outside the U.S. and Canada: If you don't have a zip code, please enter '111111' to continue.
                      </div></div></span>
               <span className="error1">
  {error && (
    zipcode === "" ? (
      <p>Please enter zip code</p>
    ) : (!Zipcode.test(zipcode?.replace(/\s/g, "")) && zipcode !== "111111") ? (
      <p>Please enter a valid zip code</p>
    ) : null
  )}
</span>

                  </div>
                </div>
                 <div className=" col-lg-6 mul-sel-div user-typee-innner">
                  <h3>
                    User Type<span className="start-color">*</span>{" "}
                    <span className="select-one"> (select one or multiple)</span>
                  </h3>
                  <Select
                    value={userTypeData}
                    options={user}
                    isMulti
                    selectMultiple={true}
                    onChange={(e) => setUserTypeData(e)}
                    ref={userRef}
                  />
                  {(error && userTypeData.length <= 0) ? (
                    <span className="error-span controlinput">
                      Please choose user type.
                    </span>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
      <div className="main-finish-get">
<div className="finish-profile">
<button onClick={UpdateProfilePage}>Add Student Portfolio
       <span className="select-one">
                      <div className="facustomeI">i<div className="tootlippillerinfo">
                        The more information you provide, the better we can personalize your experience with MatchED. Setting up your students also enables their free personalized portfolios.
                      </div></div></span>
</button>
</div>
<div className="get-started">
<button onClick={handleStartedwithMatched} disabled={isSubmitting}>Quick Start
    <span className="select-one">
                      <div className="facustomeI">i<div className="tootlippillerinfo">
                      You can always come back and add more information later.
                      </div></div></span>
</button>
</div>
      </div>
     

         
        
          </form>
        </div>
      </div>
    </>
  );
};
export default Parentrgistrationformnew;
